import { StateManager } from './stateManager';
import app from 'firebase/compat/app';
import "firebase/compat/functions"
import "firebase/compat/firestore"
import "firebase/compat/storage"
import "firebase/compat/auth"
import { getApp } from 'firebase/app';
import { initializeAuth, browserLocalPersistence } from 'firebase/auth';
import { confirmSignedOut, clearDeliberateSignOut } from './authGuard';

const config = process.env.NODE_ENV === 'development' ?
{
  apiKey: "AIzaSyA7Z0ImykMNH6e9xbI956lY-HQCEdiDTN8",
  authDomain: "skyway-dev-373d5.firebaseapp.com",
  databaseURL: "https://skyway-dev-373d5.firebaseio.com",
  projectId: "skyway-dev-373d5",
  storageBucket: "skyway-dev-373d5.appspot.com",
  messagingSenderId: "1040145803928",
  appId: "1:1040145803928:web:8310f987923f7fea5ebeed"
}
: {
  apiKey: "AIzaSyA7Z0ImykMNH6e9xbI956lY-HQCEdiDTN8",
  authDomain: "skyway-dev-373d5.firebaseapp.com",
  databaseURL: "https://skyway-dev-373d5.firebaseio.com",
  projectId: "skyway-dev-373d5",
  storageBucket: "skyway-dev-373d5.appspot.com",
  messagingSenderId: "1040145803928",
  appId: "1:1040145803928:web:8310f987923f7fea5ebeed"
};

class Firebase {
  constructor() {
    app.initializeApp(config);
    // this.geo = new GeoFirestore(app.firestore());
    Object.assign(this, app);

    // The app's login gate (ProtectedRoute / StateManager.authed) reads the
    // `authed` storage key, which is written only at manual login. This callback
    // must therefore treat the key carefully:
    //  - We only CLEAR it on a CONFIRMED sign-out. A null user is not proof of one:
    //    lost network during a token refresh and waking a backgrounded mobile tab
    //    can both emit one mid-session.
    //    Clearing the gate on any of those logged active users out. `hadUser` skips
    //    the null that precedes the first restore; confirmSignedOut (see authGuard)
    //    decides every null after it, and cancels the moment the user returns.
    //  - We RE-ESTABLISH it whenever Firebase actually has a session. This
    //    self-heals any user whose gate was already wiped: as soon as the session
    //    restores, `authed` comes back and ProtectedRoute stops bouncing them to
    //    login. Written to localStorage to match the (local-scope) persistence.
    let hadUser = false;
    let cancelPendingSignOut = null;
    const callback = user =>{
      if (user) {
        if (cancelPendingSignOut) {
          cancelPendingSignOut();
          cancelPendingSignOut = null;
        }
        // A live user makes any earlier sign-out intent moot. Cleared here so signing
        // out and straight back in within the flag's window can't make a later blip
        // look deliberate.
        clearDeliberateSignOut();
        hadUser = true;
        StateManager.user = user;
        if (!localStorage.getItem('authed') && !sessionStorage.getItem('authed')) {
          localStorage.setItem('authed', true);
        }
        return;
      }

      // Nothing to lose yet, or a verdict is already pending on an earlier null.
      if (!hadUser || cancelPendingSignOut) return;

      cancelPendingSignOut = confirmSignedOut(
        () => auth.currentUser,
        () => {
          cancelPendingSignOut = null;
          hadUser = false;
          delete StateManager.user;
          localStorage.removeItem('authed');
          sessionStorage.removeItem('authed');
        },
      );
    }

    // Auth is created here, before compat app.auth(), so compat reuses this instance
    // instead of building its default one. The default caused two load stalls:
    //  - It starts on IndexedDB. The SDK puts no timeout on IndexedDB requests, and
    //    startup runs several in sequence, so one request that never answers (another
    //    tab holding the store, a Safari IndexedDB fault) kept the app on its spinner
    //    for minutes. It also moved the session between IndexedDB and localStorage on
    //    every load, which signed every other open tab out until that load finished.
    //  - It attaches the popup/redirect resolver. On Safari and every mobile browser,
    //    startup then waits for a hidden iframe from firebaseapp.com, five requests
    //    across three Google hosts, before restoring the user.
    // localStorage only, and no resolver: startup never touches IndexedDB or the
    // iframe. Sessions already live in localStorage (the previous code moved them
    // there on every load). Both sign-in paths (email/password, PIN custom token)
    // work without the resolver; a future popup sign-in must pass one at call time.
    initializeAuth(getApp(), { persistence: browserLocalPersistence });
    const auth = app.auth();

    auth.onAuthStateChanged(callback);
  }
  
}

const firebase = new Firebase();
export default firebase;
